import React from 'react'
import { Box, Container, Typography, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import Background from '../components/Background'

export default function TermsOfService() {
  return (
    <Box component="main" sx={{ bgcolor: '#000', color: '#fff', minHeight: '100vh', position: 'relative' }}>
      <Background />
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, py: 8 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" gutterBottom sx={{ color: '#ccc' }}>
          Effective Date: July 2025
        </Typography>

        {/* Section 1 */}
        <Typography variant="h6" gutterBottom>1. Acceptance of Terms</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          By using Scout (“the Service”), you agree to comply with and be bound by these Terms of Service. If you do not agree, you must not access or use the Service.
        </Typography>

        {/* Section 2 */}
        <Typography variant="h6" gutterBottom>2. Description of Service</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Scout is a privacy-first desktop platform for discovering, installing, and running local AI agents. By default, all processing occurs locally. You may optionally enable cloud or internet-connected agents, which are governed by additional terms as outlined below.
        </Typography>

        {/* Section 3 */}
        <Typography variant="h6" gutterBottom>3. User Responsibilities</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Users of Scout must:
        </Typography>
        <ul style={{ color: '#ccc', marginTop: -8 }}>
          <li>Not attempt to reverse-engineer, decompile, or modify Scout’s core software.</li>
          <li>Use the Service in compliance with all applicable laws and regulations.</li>
          <li>Not use Scout to engage in harmful, illegal, or infringing activities.</li>
        </ul>

        {/* Section 4 */}
        <Typography variant="h6" gutterBottom>4. Developer Obligations</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Developers who create or distribute agents through Scout must:
        </Typography>
        <ul style={{ color: '#ccc', marginTop: -8 }}>
          <li>Use Scout’s official APIs and SDKs for agent submission.</li>
          <li>Not collect, transmit, or process user data outside the device without informed user consent.</li>
          <li>Comply with all relevant software licenses and intellectual property laws.</li>
        </ul>

        {/* Section 5 */}
        <Typography variant="h6" gutterBottom>5. Security and Review</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Scout Technologies reviews all submitted agents for malicious behavior or violations of platform policy. We reserve the right to suspend, remove, or block access to any agent or developer at our sole discretion to ensure platform integrity and user safety.
        </Typography>

        {/* Section 6 */}
        <Typography variant="h6" gutterBottom>6. Cloud & Internet Connectivity</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          When you enable an agent to access the internet or use cloud resources, you do so at your own risk. Scout cannot guarantee the privacy or integrity of any data once it leaves your device. The responsibility for secure cloud interaction lies with the developer and the user.
        </Typography>

        {/* Section 7 */}
        <Typography variant="h6" gutterBottom>7. Intellectual Property</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          All content, branding, and technology associated with Scout are the exclusive property of Scout Technologies. Developers retain ownership of the agent code they create but grant Scout a license to distribute, sandbox, and moderate said agents.
        </Typography>

        {/* Section 8 */}
        <Typography variant="h6" gutterBottom>8. Limitation of Liability</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          The Service is provided “as is.” Scout Technologies disclaims all warranties, including implied warranties of merchantability and fitness for a particular purpose. We are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the Service.
        </Typography>

        {/* Section 9 */}
        <Typography variant="h6" gutterBottom>9. Termination</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Scout may suspend or terminate your access to the Service at any time, without notice, for conduct that we believe violates these Terms or is otherwise harmful to the platform or its users.
        </Typography>

        {/* Section 10 */}
        <Typography variant="h6" gutterBottom>10. Governing Framework</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Scout is not governed under any single jurisdiction. In the event of a dispute, both parties agree to resolve the issue through confidential, binding arbitration under mutually agreed-upon rules.
        </Typography>

        {/* Section 11 */}
        <Typography variant="h6" gutterBottom>11. Updates to Terms</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          We may update these Terms from time to time. Any changes will be posted on this page, and your continued use of the Service signifies acceptance.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Link component={RouterLink} to="/" variant="body2" sx={{ color: '#467EE5' }}>
            ← Back to Home
          </Link>
        </Box>
      </Container>
    </Box>
  )
}
